import { defineComponent as i, computed as m, openBlock as c, createBlock as g, unref as d, mergeProps as y, withCtx as o, renderSlot as n } from "vue";
import { renderLabelAsAvatar as v } from "./ghl-ui.es321.js";
import { renderGroupLabel as p } from "./ghl-ui.es322.js";
import { renderTooltip as b } from "./ghl-ui.es323.js";
import { renderMultipleSelectedAsAvatar as h, renderSingleSelectedAsAvatar as S } from "./ghl-ui.es324.js";
import B from "./ghl-ui.es325.js";
const w = i({
  name: "UISelect",
  inheritAttrs: !1
}), A = i({
  ...w,
  props: {
    id: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    },
    multiple: {
      type: Boolean,
      default: void 0
    },
    filterable: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: void 0
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    remote: {
      type: Boolean,
      default: void 0
    },
    tag: {
      type: Boolean,
      default: void 0
    },
    type: {
      type: String,
      default: "default"
    },
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "large"
    },
    maxTagCount: {
      type: Number,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String
    },
    value: {
      type: [String, Array]
    },
    renderLabel: {
      type: Function,
      default: void 0
    },
    renderTag: {
      type: Function,
      default: void 0
    },
    showTooltip: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["search", "update:value", "scroll"],
  setup(e) {
    const r = e, u = (t, a) => {
      switch (t.type ?? r.type) {
        case "avatar":
        default:
          return v(t);
        case "group":
          return p(t);
      }
    }, s = m(() => {
      switch (r.type) {
        case "avatar":
          return r.multiple ? h : S;
        case "default":
        default:
          return;
      }
    });
    return (t, a) => (c(), g(d(B), y({
      "reset-menu-on-options-change": e.resetMenuOnOptionsChange,
      "render-label": e.renderLabel ? e.renderLabel : e.type === "avatar" ? u : e.showTooltip ? d(b) : void 0,
      "render-tag": e.renderTag ? e.renderTag : s.value,
      id: e.id
    }, t.$attrs, {
      placeholder: e.placeholder,
      options: e.options,
      disabled: e.disabled,
      value: e.value,
      class: "hl-select",
      filterable: e.filterable,
      show: e.show,
      multiple: e.multiple,
      loading: e.loading,
      clearable: e.clearable,
      remote: e.remote,
      tag: e.tag,
      size: e.size,
      "max-tag-count": e.maxTagCount,
      onScroll: a[0] || (a[0] = (l) => t.$emit("scroll", l)),
      onSearch: a[1] || (a[1] = (l) => t.$emit("search", l)),
      "onUpdate:value": a[2] || (a[2] = (l, f) => t.$emit("update:value", l, f))
    }), {
      action: o(() => [
        n(t.$slots, "action")
      ]),
      arrow: o(() => [
        n(t.$slots, "arrow")
      ]),
      empty: o(() => [
        n(t.$slots, "empty")
      ]),
      _: 3
    }, 16, ["reset-menu-on-options-change", "render-label", "render-tag", "id", "placeholder", "options", "disabled", "value", "filterable", "show", "multiple", "loading", "clearable", "remote", "tag", "size", "max-tag-count"]));
  }
}), M = A;
export {
  M as default
};
